import React, { useState } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';
import classNames from 'classnames';
//import { Link } from 'react-router-dom';
import OrdersTableHeader from './OrdersTableHeader';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import CardDropdown from 'components/common/CardDropdown';
import { orders } from './DataOrders';

const columns = [
 {
  accessor: 'id',
  Header: 'Order',
  headerProps: { className: 'pe-1' },
  cellProps: {
   className: 'py-2'
  },
  Cell: rowData => {
   const { id, clients } = rowData.row.original;
   return (
    <>
     {/* <Link to={`/orderdetails/${id}`} target="_blank" rel="noopener noreferrer"></Link> */}
     <strong>Numero de Orden {id}</strong> del <strong>Cliente {clients}</strong> <br />
    </>
   );
  }
 },
 {
  accessor: 'createAt',
  Header: 'Date',
  headerProps: { className: 'pe-7' },
  Cell: rowData => {
   const { createAt } = rowData.row.original;
   const formattedDate = new Date(createAt).toLocaleString();
   return formattedDate;
  }
 },
 {
  accessor: 'adviser',
  Header: 'Vendedor',
  Cell: rowData => {
   const { adviser } = rowData.row.original;
   return <>{adviser}</>;
  }
 },
 {
  accessor: 'status',
  Header: 'Status',
  headerProps: {
   className: 'text-center'
  },
  cellProps: {
   className: 'fs-0'
  },
  Cell: rowData => {
   const { status } = rowData.row.original;
   return (
    <SoftBadge
     pill
     bg={classNames({
      success: status === 'Completed',
      primary: status === 'In Progress',
      warning: status === 'Pending',
      secondary: status === 'On Hold'
     })}
     className="d-flex flex-center"
    >
     <p className="mb-0">{status}</p>
     <FontAwesomeIcon
      icon={classNames({
       check: status === 'Completed',
       redo: status === 'In Progress',
       stream: status === 'Pending',
       ban: status === 'On Hold'
      })}
      transform="shrink-2"
      className="ms-1"
     />
    </SoftBadge>
   );
  }
 },
 {
  accessor: 'value',
  Header: 'Amount',
  headerProps: {
   className: 'text-end'
  },
  cellProps: {
   className: 'text-end fs-0 fw-medium py-2'
  },
  Cell: rowData => {
   const originalValue = rowData.row.original.value;
   const discount = rowData.row.original.discounts;
   const discountedValue = originalValue - discount;

   return (
    <div>
     <h4 className="text-end fs-0 fw-medium py-2">{`$${discountedValue.toFixed(2)}`}</h4>
     {discount > 0 && (
      <h5 className="fs--2 text-500 mb-0 mt-1">
       <del>{`$${originalValue.toFixed(2)}`}</del>
       <span className="ms-2">{`-${discount}`}</span>
      </h5>
     )}
    </div>
   );
  }
 },
 {
  accessor: 'none',
  Header: '',
  disableSortBy: true,
  cellProps: {
   className: 'text-end'
  },
  Cell: rowData => {
   const { id, adviser, clients } = rowData.row.original;
   return (
    <CardDropdown>
     <div className="py-2">
      <Dropdown.Item href={`/orderdetails/${id}`} target="_blank" rel="noopener noreferrer">
       View Order {id}
      </Dropdown.Item>
      <Dropdown.Item>View Vendedor {adviser}</Dropdown.Item>
      <Dropdown.Item>View Cliente {clients}</Dropdown.Item>
      <Dropdown.Divider as="div" />
      <Dropdown.Item href="#!" className="text-danger">
       Delete
      </Dropdown.Item>
     </div>
    </CardDropdown>
   );
  }
 }
];

const Orders = () => {
 const [filteredOrders, setFilteredOrders] = useState(orders);

 // Función para manejar la búsqueda
 const handleSearch = term => {
  // Filtrar las órdenes en función del término de búsqueda
  const filtered = orders.filter(order => {
   return (
    order.id.toString().includes(term) ||
    order.clients.toString().includes(term) ||
    order.status.toLowerCase().includes(term.toLowerCase()) ||
    order.adviser.toString().includes(term)
   );
  });

  setFilteredOrders(filtered);
 };
 return (
  <AdvanceTableWrapper columns={columns} data={filteredOrders} selection sortable pagination perPage={10}>
   <Card className="mb-3">
    <Card.Header>
     <OrdersTableHeader table onSearch={handleSearch} />
    </Card.Header>
    <Card.Body className="p-0">
     <AdvanceTable
      table
      headerClassName="bg-200 text-900 text-nowrap align-middle"
      rowClassName="align-middle white-space-nowrap"
      tableProps={{
       size: 'sm',
       striped: true,
       className: 'fs--1 mb-0 overflow-hidden'
      }}
     />
    </Card.Body>
    <Card.Footer>
     <AdvanceTablePagination table />
    </Card.Footer>
   </Card>
  </AdvanceTableWrapper>
 );
};

export default Orders;
